// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  
}

.fixed {
  position: fixed
}

.relative {
  position: relative
}

.bottom-0 {
  bottom: 0px
}

.right-0 {
  right: 0px
}

.z-300 {
  z-index: 300
}

.col-span-1 {
  grid-column: span 1 / span 1
}

.col-span-2 {
  grid-column: span 2 / span 2
}

.col-span-3 {
  grid-column: span 3 / span 3
}

.m-0 {
  margin: 0px
}

.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem
}

.mb-5 {
  margin-bottom: 1.25rem
}

.ml-2 {
  margin-left: 0.5rem
}

.box-content {
  box-sizing: content-box
}

.block {
  display: block
}

.flex {
  display: flex
}

.grid {
  display: grid
}

.contents {
  display: contents
}

.hidden {
  display: none
}

.h-10 {
  height: 2.5rem
}

.w-full {
  width: 100%
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

.cursor-auto {
  cursor: auto
}

.cursor-pointer {
  cursor: pointer
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr))
}

.flex-row {
  flex-direction: row
}

.flex-col {
  flex-direction: column
}

.items-center {
  align-items: center
}

.justify-center {
  justify-content: center
}

.justify-between {
  justify-content: space-between
}

.gap-2 {
  gap: 0.5rem
}

.gap-5 {
  gap: 1.25rem
}

.whitespace-nowrap {
  white-space: nowrap
}

.rounded {
  border-radius: 0.25rem
}

.rounded-lg {
  border-radius: 0.5rem
}

.rounded-tl-lg {
  border-top-left-radius: 0.5rem
}

.border {
  border-width: 1px
}

.border-l {
  border-left-width: 1px
}

.border-t {
  border-top-width: 1px
}

.border-hgk-alto-gray {
  --tw-border-opacity: 1;
  border-color: rgb(10 0 25 / var(--tw-border-opacity))
}

.border-l-hgk-downriver-blue {
  --tw-border-opacity: 1;
  border-left-color: rgb(7 31 58 / var(--tw-border-opacity))
}

.border-t-hgk-downriver-blue {
  --tw-border-opacity: 1;
  border-top-color: rgb(7 31 58 / var(--tw-border-opacity))
}

.bg-hgk-alto-gray {
  --tw-bg-opacity: 1;
  background-color: rgb(10 0 25 / var(--tw-bg-opacity))
}

.bg-hgk-downriver-blue {
  --tw-bg-opacity: 1;
  background-color: rgb(7 31 58 / var(--tw-bg-opacity))
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}

.p-0 {
  padding: 0px
}

.p-3 {
  padding: 0.75rem
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem
}

.font-bold {
  font-weight: 700
}

.text-hgk-downriver-blue {
  --tw-text-opacity: 1;
  color: rgb(7 31 58 / var(--tw-text-opacity))
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}

.underline {
  text-decoration-line: underline
}

.opacity-40 {
  opacity: 0.4
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}

.hover\\:bg-hgk-emperor-gray:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 88 155 / var(--tw-bg-opacity))
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}

.hover\\:shadow-soft:hover {
  --tw-shadow: 0px 4px 24px rgba(9, 44, 76, 0.1);
  --tw-shadow-colored: 0px 4px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

@media (min-width: 768px) {
  .md\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem
  }

  .md\\:mb-5 {
    margin-bottom: 1.25rem
  }

  .md\\:w-144 {
    width: 36rem
  }

  .md\\:justify-between {
    justify-content: space-between
  }

  .md\\:gap-5 {
    gap: 1.25rem
  }

  .md\\:p-10 {
    padding: 2.5rem
  }

  .md\\:p-5 {
    padding: 1.25rem
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem
  }

  .md\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem
  }
}`, "",{"version":3,"sources":["webpack://./src/layout/Cookie/CookiesCompiled.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB;AACF;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gKAAgK;EAChK,wJAAwJ;EACxJ,iLAAiL;EACjL,wDAAwD;EACxD;AACF;;AAEA;EACE,wBAAwB;EACxB,wDAAwD;EACxD;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,8CAA8C;EAC9C,wDAAwD;EACxD;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,oBAAoB;IACpB;EACF;;EAEA;IACE,qBAAqB;IACrB;EACF;;EAEA;IACE,qBAAqB;IACrB;EACF;;EAEA;IACE,kBAAkB;IAClB;EACF;AACF","sourcesContent":["*, ::before, ::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n  --tw-contain-size:  ;\n  --tw-contain-layout:  ;\n  --tw-contain-paint:  ;\n  --tw-contain-style:  \n}\n\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n  --tw-contain-size:  ;\n  --tw-contain-layout:  ;\n  --tw-contain-paint:  ;\n  --tw-contain-style:  \n}\n\n.fixed {\n  position: fixed\n}\n\n.relative {\n  position: relative\n}\n\n.bottom-0 {\n  bottom: 0px\n}\n\n.right-0 {\n  right: 0px\n}\n\n.z-300 {\n  z-index: 300\n}\n\n.col-span-1 {\n  grid-column: span 1 / span 1\n}\n\n.col-span-2 {\n  grid-column: span 2 / span 2\n}\n\n.col-span-3 {\n  grid-column: span 3 / span 3\n}\n\n.m-0 {\n  margin: 0px\n}\n\n.my-3 {\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem\n}\n\n.mb-5 {\n  margin-bottom: 1.25rem\n}\n\n.ml-2 {\n  margin-left: 0.5rem\n}\n\n.box-content {\n  box-sizing: content-box\n}\n\n.block {\n  display: block\n}\n\n.flex {\n  display: flex\n}\n\n.grid {\n  display: grid\n}\n\n.contents {\n  display: contents\n}\n\n.hidden {\n  display: none\n}\n\n.h-10 {\n  height: 2.5rem\n}\n\n.w-full {\n  width: 100%\n}\n\n.transform {\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))\n}\n\n.cursor-auto {\n  cursor: auto\n}\n\n.cursor-pointer {\n  cursor: pointer\n}\n\n.grid-cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr))\n}\n\n.flex-row {\n  flex-direction: row\n}\n\n.flex-col {\n  flex-direction: column\n}\n\n.items-center {\n  align-items: center\n}\n\n.justify-center {\n  justify-content: center\n}\n\n.justify-between {\n  justify-content: space-between\n}\n\n.gap-2 {\n  gap: 0.5rem\n}\n\n.gap-5 {\n  gap: 1.25rem\n}\n\n.whitespace-nowrap {\n  white-space: nowrap\n}\n\n.rounded {\n  border-radius: 0.25rem\n}\n\n.rounded-lg {\n  border-radius: 0.5rem\n}\n\n.rounded-tl-lg {\n  border-top-left-radius: 0.5rem\n}\n\n.border {\n  border-width: 1px\n}\n\n.border-l {\n  border-left-width: 1px\n}\n\n.border-t {\n  border-top-width: 1px\n}\n\n.border-hgk-alto-gray {\n  --tw-border-opacity: 1;\n  border-color: rgb(10 0 25 / var(--tw-border-opacity))\n}\n\n.border-l-hgk-downriver-blue {\n  --tw-border-opacity: 1;\n  border-left-color: rgb(7 31 58 / var(--tw-border-opacity))\n}\n\n.border-t-hgk-downriver-blue {\n  --tw-border-opacity: 1;\n  border-top-color: rgb(7 31 58 / var(--tw-border-opacity))\n}\n\n.bg-hgk-alto-gray {\n  --tw-bg-opacity: 1;\n  background-color: rgb(10 0 25 / var(--tw-bg-opacity))\n}\n\n.bg-hgk-downriver-blue {\n  --tw-bg-opacity: 1;\n  background-color: rgb(7 31 58 / var(--tw-bg-opacity))\n}\n\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity))\n}\n\n.p-0 {\n  padding: 0px\n}\n\n.p-3 {\n  padding: 0.75rem\n}\n\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem\n}\n\n.text-xl {\n  font-size: 1.25rem;\n  line-height: 1.75rem\n}\n\n.font-bold {\n  font-weight: 700\n}\n\n.text-hgk-downriver-blue {\n  --tw-text-opacity: 1;\n  color: rgb(7 31 58 / var(--tw-text-opacity))\n}\n\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity))\n}\n\n.underline {\n  text-decoration-line: underline\n}\n\n.opacity-40 {\n  opacity: 0.4\n}\n\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)\n}\n\n.transition {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms\n}\n\n.transition-all {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms\n}\n\n.hover\\:bg-hgk-emperor-gray:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 88 155 / var(--tw-bg-opacity))\n}\n\n.hover\\:text-white:hover {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity))\n}\n\n.hover\\:shadow-soft:hover {\n  --tw-shadow: 0px 4px 24px rgba(9, 44, 76, 0.1);\n  --tw-shadow-colored: 0px 4px 24px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)\n}\n\n@media (min-width: 768px) {\n  .md\\:mx-5 {\n    margin-left: 1.25rem;\n    margin-right: 1.25rem\n  }\n\n  .md\\:mb-5 {\n    margin-bottom: 1.25rem\n  }\n\n  .md\\:w-144 {\n    width: 36rem\n  }\n\n  .md\\:justify-between {\n    justify-content: space-between\n  }\n\n  .md\\:gap-5 {\n    gap: 1.25rem\n  }\n\n  .md\\:p-10 {\n    padding: 2.5rem\n  }\n\n  .md\\:p-5 {\n    padding: 1.25rem\n  }\n\n  .md\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem\n  }\n\n  .md\\:px-5 {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem\n  }\n\n  .md\\:px-7 {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem\n  }\n\n  .md\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
